import {
  JavascriptOriginal,
  PythonOriginal,
  Html5Original,
  Css3Original,
  ExpressOriginal,
  ReactOriginal,
  NextjsOriginal,
  TailwindcssOriginal,
  BootstrapPlain,
  NodejsOriginal,
  MongodbPlain,
  PostmanPlain,
  CPlain,
  DjangoPlain,
  MysqlOriginalWordmark,
  PostgresqlOriginal,
  PhotoshopOriginal,
  FigmaOriginal,
} from "devicons-react";

// Constants
const githubLink = "https://github.com/myselfshivams";

// Profile Description
export const profileDescription = [
  "Hello 👋, I'm Shivam and currently pursuing Computer Science at PSIT Kanpur. Feel free to reach out to me at contact@itshivam.me ✨ I have a strong interest in Machine Learning, Deep Learning, and Data Analytics. Over the past 3 years, I have built several innovative web, app, and software solutions. I'm passionate about using technology to solve real-world problems and exploring advancements in AI and Computer Vision.!",
];

// Work Experience Template
export const workExperienceTemplate = [
  {
    key: 1,
    company: "", // Add company name here
    description: [
      "", // Add description points here
    ],
    duration: "", // Add duration here
    designation: "", // Add designation here
    type: "work",
  },
];

// GitHub Repositories
export const githubRepos = [
 
  {
    name: "Studex Portal",
    techUsed: ["Next.js", "PostgreSQL", "Django"],
    description:
      "Studex Portal is a comprehensive platform designed for managing academic and student-related activities seamlessly.",
      githubLink: `${githubLink}/#`,
    liveURL: "https://studex.tech/",
  },
  {
    name: "Bus Scout",
    techUsed: ["Next.js", "MongoDB", "PostgreSQL", "Django"],
    description:
      "Bus Scout is an innovative bus tracking system that provides real-time updates on bus locations, ensuring efficient and stress-free commuting.",
      githubLink: `${githubLink}/#`,
    liveURL: "https://bus-scout.studex.tech/",
  },
  {
    name: "eShielded Assessment",
    techUsed: ["Django", "Next.js", "PostgreSQL"],
    description:
      "eShielded Assessment is a secure platform for conducting online assessments, featuring advanced anti-cheating measures and seamless user experience.",
      githubLink: `${githubLink}/#`,
    liveURL: "https://eshielded.itshivam.me/",
  },
  {
    name: "Right Resource FIT",
    techUsed: ["React", "Express", "MongoDB"],
    description:
      "Right Resource FIT is a hiring platform aimed at connecting employers with the right talent efficiently, leveraging modern technology for seamless recruitment.",
    githubLink: `${githubLink}/#`,
    liveURL: "https://team4.itshivam.me/",
  },
 
 
];


// Education Experience
export const educationExperience = [
  {
    key: 1,
    institution: "Pranveer Singh Institute of Technology",
    graduation: "May 2026",
    degree: "B.Tech",
    type: "education",
  },
  {
    key: 2,
    institution: "Central Board of Secondary Education",
    graduation: "July 2022",
    degree: "XII",
    type: "education",
  },
];

const iconSize = 15;
const iconClass = "mx-auto";

export const skills = [
  {
    key: 1,
    name: "Python",
    type: "language",
    icon: PythonOriginal ? (
      <PythonOriginal className={iconClass} size={iconSize} />
    ) : null,
  },
  {
    key: 2,
    name: "JavaScript",
    type: "language",
    icon: JavascriptOriginal ? (
      <JavascriptOriginal className={iconClass} size={iconSize} />
    ) : null,
  },
  {
    key: 3,
    name: "HTML",
    type: "language",
    icon: Html5Original ? (
      <Html5Original className={iconClass} size={iconSize} />
    ) : null,
  },
  {
    key: 4,
    name: "CSS",
    type: "language",
    icon: Css3Original ? (
      <Css3Original className={iconClass} size={iconSize} />
    ) : null,
  },
  {
    key: 5,
    name: "React",
    type: "framework",
    icon: ReactOriginal ? (
      <ReactOriginal className={iconClass} size={iconSize} />
    ) : null,
  },
  {
    key: 6,
    name: "Next.js",
    type: "framework",
    icon: NextjsOriginal ? (
      <NextjsOriginal className={iconClass} size={iconSize} />
    ) : null,
  },
  {
    key: 7,
    name: "TailwindCSS",
    type: "framework",
    icon: TailwindcssOriginal ? (
      <TailwindcssOriginal className={iconClass} size={iconSize} />
    ) : null,
  },
  {
    key: 8,
    name: "Bootstrap",
    type: "framework",
    icon: BootstrapPlain ? (
      <BootstrapPlain className={iconClass} size={iconSize} />
    ) : null,
  },
  {
    key: 9,
    name: "Node.JS",
    type: "framework",
    icon: NodejsOriginal ? (
      <NodejsOriginal className={iconClass} size={iconSize} />
    ) : null,
  },
  {
    key: 10,
    name: "MongoDB",
    type: "database",
    icon: MongodbPlain ? (
      <MongodbPlain className={iconClass} size={iconSize} />
    ) : null,
  },
  {
    key: 11,
    name: "Postman",
    type: "tool",
    icon: PostmanPlain ? (
      <PostmanPlain className={iconClass} size={iconSize} />
    ) : null,
  },
  {
    key: 12,
    name: "C",
    type: "language",
    icon: CPlain ? <CPlain className={iconClass} size={iconSize} /> : null,
  },
  {
    key: 13,
    name: "Express",
    type: "framework",
    icon: ExpressOriginal ? (
      <ExpressOriginal className={iconClass} size={iconSize} />
    ) : null,
  },
  {
    key: 14,
    name: "Django",
    type: "framework",
    icon: DjangoPlain ? (
      <DjangoPlain className={iconClass} size={iconSize} />
    ) : null,
  },
  {
    key: 15,
    name: "MySQL",
    type: "database",
    icon: MysqlOriginalWordmark ? (
      <MysqlOriginalWordmark className={iconClass} size={iconSize} />
    ) : null,
  },
  {
    key: 16,
    name: "PostgreSQL",
    type: "database",
    icon: PostgresqlOriginal ? (
      <PostgresqlOriginal className={iconClass} size={iconSize} />
    ) : null,
  },
 
  {
    key: 18,
    name: "Photoshop",
    type: "tool",
    icon: PhotoshopOriginal ? (
      <PhotoshopOriginal className={iconClass} size={iconSize} />
    ) : null,
  },
  {
    key: 19,
    name: "Figma",
    type: "tool",
    icon: FigmaOriginal ? (
      <FigmaOriginal className={iconClass} size={iconSize} />
    ) : null,
  },
];

const appsData = [
  {
    id: 1,
    name: "Google Chrome",
    icon: "/images/apps/chrome.png",
    action: "browser",
    size: "w-18 h-18",
  },
  {
    id: 2,
    name: "About Me",
    icon: "/images/apps/folder.png",
    action: "explorer",
    size: "w-18 h-18",
  },
  {
    id: 3,
    name: "Recycle Bin",
    icon: "/images/apps/recyclebin.png",
    action: "recycle",
    size: "w-14 h-14",
  },
  {
    id: 4,
    name: "Microsoft Edge",
    icon: "/images/apps/edge.png",
    action: "browser",
    size: "w-11 h-11",
  },
  {
    id: 5,
    name: "Calculator",
    icon: "/images/apps/calculator.png",
    action: "calculator",
    size: "w-11 h-11",
  },
  {
    id: 6,
    name: "VS Code",
    icon: "https://laaouatni.github.io/w11CSS/images/vs-code.ico",
    action: "vscode",
    size: "w-8 h-8",
  },
  {
    id: 7,
    name: "Studex Portal",
    icon: "https://v1.itshivam.me/images/logos/logo.png",
    action: "app",
    subAction: "studex",
    size: "w-10 h-10",
  },
  {
    id: 8,
    name: "Spotify",
    icon: "https://www.freepnglogos.com/uploads/spotify-logo-png/image-gallery-spotify-logo-21.png",
    action: "app",
    subAction: "spotify",
    size: "w-10 h-10",
  },
  {
    id: 9,
    name: "Ignitia 2k25",
    icon: "https://v1.itshivam.me/themes/Yaru/system/ignitia.svg",
    action: "app",
    subAction: "ignitia",
    size: "w-10 h-10",
  },
];

// Export default data
export default appsData;

// Social Media Links
export const socialMediaLinks = {
  linkedin: "https://www.linkedin.com/in/ershivams/",
  github: githubLink,
};
